export default __webpack_public_path__ + "static/media/grid.0a11e324.svg";